import React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Box } from '@lightspeed/flame/Core';

type DangerAlertProps = {
  noCloseBtn?: boolean;
  title?: string;
  message: string | React.ReactNode;
  dataTest?: string;
};

export const WarningAlert = ({
  noCloseBtn = false,
  title,
  message,
  dataTest = 'warning-alert',
}: DangerAlertProps) => {
  return (
    <>
      <Alert data-test={dataTest} type="warning" noCloseBtn={noCloseBtn} title={title} mt={2}>
        <Box data-test="warning-alert-message">{message}</Box>
      </Alert>
    </>
  );
};
